var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadedFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none",
    viewBox: "0 0 20 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    y: 0.986,
    fill: "#1E0AF5",
    rx: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10.833 10.57h-2.5m.834 1.666h-.834m3.334-3.333H8.333m5-.083v4.333c0 .7 0 1.05-.136 1.318a1.25 1.25 0 0 1-.546.546c-.268.136-.618.136-1.318.136H8.667c-.7 0-1.05 0-1.318-.136a1.25 1.25 0 0 1-.546-.546c-.136-.268-.136-.618-.136-1.318V8.82c0-.7 0-1.05.136-1.318a1.25 1.25 0 0 1 .546-.546c.268-.136.618-.136 1.318-.136h2.666c.7 0 1.05 0 1.318.136.235.12.426.311.546.546.136.268.136.618.136 1.318Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5 5.986h10v10H5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadedFile);
export default __webpack_public_path__ + "static/media/uploaded-file.c3550ce056600ca86e529cb7a401a80f.svg";
export { ForwardRef as ReactComponent };